<template>
  <edit-modal
    caption="Leervraag bewerken"
    :isActive="isActive">
    <div class="field">
      <div class="card">
        <div class="card-header">
          <p class="card-header-title">Tekst uit het kwalificatiedossier</p>
        </div>

        <div class="card-content">
          <div class="content" v-html="text"></div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <p class="card-header-title">Tekst leervraag</p>
        </div>

        <div class="card-content">
          <div class="field">
            <div v-if="bundles.length > 0" class="control">
              <textarea class="textarea" v-model="value"></textarea>
            </div>

            <div v-else class="notification is-warning">
              Dit profiel is niet gekoppeld aan een bundel. Een beheerder moet het profiel eerst koppelen aan minimaal 1 bundel voor er leervragen aan toegevoegd kunnen worden.
            </div>
          </div>
        </div>
      </div>

      <template v-if="!inAdmin">
        <hr>

        <div class="field">
          <label class="label">Opslaan in bundels</label>
          <div class="select is-multiple">
            <select multiple v-model="myBundles" disabled>
              <option v-for="bundle in dossier.bundles" :value="bundle.id" :key="bundle.id">{{ bundle.name }}</option>
            </select>
          </div>
        </div>
      </template>

      <save-buttons
        :disabled="!valid"
        @save="save"
        @cancel="close">
      </save-buttons>
    </div>
  </edit-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import EditModal from '@/components/modules/EditModal'
import SaveButtons from '@/components/modules/SaveButtons'

export default {
  props: [
    'text',
    'question',
    'isActive'
  ],
  components: {
    EditModal,
    SaveButtons
  },
  data () {
    return {
      value: null
    }
  },
  computed: {
    ...mapGetters({
      source: 'dossiers/source',
      dossier: 'dossiers/dossier',
      bundles: 'bundles/bundles'
    }),
    myBundles () {
      if (this.dossier && this.question) {
        let relevantBundles = (this.question.profile_number) ? this.dossier.bundles.filter((bundle) => {
          return bundle.profile_nr === parseInt(this.question.profile_number)
        }) : this.dossier.bundles

        return relevantBundles.map(bundle => bundle.id).filter((bundle) => {
          return this.bundles.map(bundle => bundle.id).includes(bundle)
        })
      }

      return []
    },
    valid () {
      return this.value !== null && this.value.length > 0
    },
    inAdmin () {
      return this.$route.name === 'edit-dossier'
    }
  },
  created () {
    this.setValue()
  },
  watch: {
    question () {
      this.setValue()
    }
  },
  methods: {
    save () {
      this.$emit('save', {
        value: this.value,
        bundles: this.myBundles
      })

      this.close()
    },
    close () {
      this.$emit('close')
    },
    setValue () {
      if (this.question) {
        this.value = this.question.value
      }
    }
  }
}
</script>

<style scoped>
  .modal-content {
    width: 80%;
  }
</style>
